import { ApplicationEnvironment } from '../../entities/catalog/application.environment';
import { EnvironmentConfiguration } from './environment.configuration';

export const environmentVnext = {
  locale: 'en-AU',
  production: false,
  api: '/api',
  domain: 'workbuddy.io',
  auth: {
    local: {
      callbackUrl: 'http://{0}:4000/callback',
    }
  },
  jms: {
    loginHref: 'https://id.workbuddy.io',
    logoutHref: 'https://id.workbuddy.io/logout',
    captcha: '6LfQ01oUAAAAAFfG2a8ZR509QugrxclKGsINjcKN',
    captchaSecret: '6LfQ01oUAAAAAFfjjGsSDeMfCc9ZPTAMswBcBh8y',
  },
  sentry: {
    dsn: '',
    name: '',
    release: '',
    environment: ''
  },
  environment: ApplicationEnvironment.Nightly,
} as EnvironmentConfiguration;
